import Viewer from "viewerjs";
import "viewerjs/dist/viewer.min.css";

let viewerInstance = null;
let container = null;

const HIGH_Z_INDEX = 9999;

function getContainer() {
  if (!container) {
    container = document.createElement("div");
    container.id = "global-image-viewer-container";
    container.style.position = "fixed";
    container.style.top = "-9999px";
    container.style.left = "-9999px";
    container.style.opacity = "0";
    container.style.pointerEvents = "none";
    container.style.zIndex = HIGH_Z_INDEX;

    document.body.appendChild(container);
  }
  return container;
}

export function previewImage(targetImg, options = {}) {
  if (!targetImg || targetImg.tagName !== "IMG") {
    console.warn("[GlobalImageViewer] Invalid image element:", targetImg);
    return;
  }
  const container = getContainer();
  container.innerHTML = "";
  const parent = targetImg.parentElement;
  const images = parent
    ? Array.from(parent.querySelectorAll("img")).filter((img) => img.src)
    : [targetImg];

  if (images.length === 0) {
    console.warn("[GlobalImageViewer] No valid images found.");
    return;
  }

  images.forEach((img) => {
    const clonedImg = img.cloneNode(true);
    container.appendChild(clonedImg);
  });
  if (viewerInstance) {
    viewerInstance.destroy();
    viewerInstance = null;
  }

  const index = images.indexOf(targetImg);

  viewerInstance = new Viewer(container, {
    inline: false,
    navbar: true,
    title: false,
    toolbar: {
      zoomIn: 1,
      zoomOut: 1,
      oneToOne: 1,
      reset: 1,
      prev: 1,
      play: 0,
      next: 1,
      rotateLeft: 1,
      rotateRight: 1,
      flipHorizontal: 1,
      flipVertical: 1,
      fullscreen: 1,
    },
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    fullscreen: true,
    transition: false,

    keyboard: true,

    ...options,

    ready() {
      const viewerContainer = document.querySelector(".viewer-container");
      if (viewerContainer) {
        viewerContainer.style.zIndex = HIGH_Z_INDEX + 10;
      }
      const layers = document.querySelectorAll(
        ".viewer-container, .viewer-backdrop, .viewer-toolbar, .viewer-navbar",
      );
      layers.forEach((el) => {
        el.style.zIndex = HIGH_Z_INDEX + 10;
      });
    },

    viewed() {
      console.log("[GlobalImageViewer] Viewer 已渲染完成");
    },
    shown() {
      console.log("[GlobalImageViewer] Viewer 已显示");
    },
    hidden() {
      console.log("[GlobalImageViewer] Viewer 已关闭");
    },
  });
  setTimeout(() => {
    viewerInstance.view(index);
  }, 50);
}

export function closeGlobalViewer() {
  if (viewerInstance) {
    viewerInstance.hide();
  }
}

export function destroyGlobalViewer() {
  if (viewerInstance) {
    viewerInstance.destroy();
    viewerInstance = null;
  }
  if (container && container.parentNode) {
    container.parentNode.removeChild(container);
    container = null;
  }
}

window.addEventListener?.("beforeunload", () => {
  destroyGlobalViewer();
});
